module.exports = __webpack_public_path__ + "static/media/image-courses-2.50a56aa6.png";